<div class="dialog-card-view">
    <h1 class="dc-title-xl dc-text-center">Penal charges details</h1>

    <mat-dialog-content>
        <section class="analytics-data-table-control">
            <table>
                <thead>
                    <tr>
                        <th>DPD</th>
                        <th>Fixed penalty charges</th>
                        <th>Variable penal charges</th>
                        <th>Per day penalty amount</th>
                        <th>Penalty day</th>
                        <th>Total penalty</th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let item of penalCharges">
                        <tr *ngIf="item?.penaltyAmount > 0">
                            <td>{{ item?.startDay }} - {{ item?.endDay }}</td>

                            <td>
                                {{
                                    item?.penaltyCharge || 0
                                        | defaultBlank : "number" : { symbol: "₹", position: "before" }
                                }}
                            </td>

                            <td>
                                {{
                                    item?.incrementalCharges || 0
                                        | defaultBlank : "number" : { symbol: "₹", position: "before" }
                                }}
                            </td>

                            <td>
                                {{
                                    item?.perDayInterest || 0
                                        | defaultBlank : "number" : { symbol: "₹", position: "before" }
                                }}
                            </td>
                            <td>{{ item?.day }}</td>
                            <td>
                                {{
                                    item?.penaltyAmount || 0
                                        | defaultBlank : "number" : { symbol: "₹", position: "before" }
                                }}
                            </td>
                        </tr>
                    </ng-container>

                    <!-- Dynamic total row -->
                    <tr *ngIf="penalChargesDetails?.pInterestRateTAmt > 0">
                        <td colspan="5" class="text-align-end bold-text">
                            Penalties amount for {{ penalChargesDetails?.pDays }} days
                        </td>
                        <td class="bold-text">
                            {{
                                penalChargesDetails?.pInterestRateTAmt
                                    | defaultBlank : "number" : { symbol: "₹", position: "before" }
                            }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>
    </mat-dialog-content>

    <mat-dialog-actions>
        <div class="dialog-action-wrapper">
            <button type="button" class="btn text-btn fit-btn" mat-dialog-close>Close</button>
        </div>
    </mat-dialog-actions>
</div>
